import React from 'react'
import { Provider } from 'react-redux'
import { includes } from 'lodash'
import { PersistGate } from 'redux-persist/integration/react'
import { ThemeProvider } from 'styled-components'

import { THEME } from '../../core/constants'
import { getEnvironmentVariable } from '../../core/helpers'
import { initSentry } from '../../core/services'

import { persistor, store } from '../redux'

import Bootstrap from './bootstrap'
import MainRouter from './main-router'

if (getEnvironmentVariable('NODE_ENV') !== 'development') {
  initSentry({
    dsn: getEnvironmentVariable('REACT_APP_SENTRY_DSN'),
    environment: getEnvironmentVariable('REACT_APP_SENTRY_APP_ENVIRONMENT'),
    beforeSend: event => {
      const {
        exception: { values },
      } = event

      if (includes(values[0].value, 'ResizeObserver loop limit exceeded')) {
        return null
      }

      return event
    },
  })
}

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={THEME}>
        <Bootstrap>
          <MainRouter />
        </Bootstrap>
      </ThemeProvider>
    </PersistGate>
  </Provider>
)

export default App
